import React, { useEffect, useState } from "react";
import {Container ,Input, Button } from "reactstrap";
import { Formik,Form,Field } from "formik";
import { Loading } from "../../share/loading";
import "../../share/form.css";
import './ProposalStyle.css'
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css'
import { NumberWithCommas } from "../../share/NumberWithCommas";
import {TiTick} from "react-icons/ti"
import { RenderCustomHeader } from "../../share/RenderCustomHeader";
import { ConvertDateToThaiBuddhist } from "../../share/ConvertDateToThaiBuddhist";
import { ConvertDateFormat } from "../../share/ConvertDateFormat";

export function ProposedToTheSubCommittee4ViewComponent () {
  
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [meetingDate, setMeetingDate] = useState("")
    const [meetingYear, setMeetingYear] = useState("")
    const [meetingNo, setMeetingNo] = useState("")
    console.log("meetingNo", meetingNo)
    console.log("meetingYear", meetingYear)
    console.log("meetingDate", meetingDate)
    const [meetingYearSelect, setMeetingYearSelect] = useState([])
    console.log("meetingYearselect",meetingYearSelect)
    const [meetingNoSelect, setMeetingNoSelect] = useState([])


    useEffect(() => {
        async function GetMeetingForSelect () {
          setLoading(true)
          try{
            let res = await fetch(`api/ProposalBorrow/getMeetingNoSelectTest`);
            let resJson = await res.json();
            console.log(resJson.dataenum)
            setMeetingNoSelect(resJson.dataenum);
            // console.log("borrowInfo", resJson.dataenum);
          } catch(e) {
            console.log("err =>",e)
    
          } finally {
            setLoading(false)
          }
        }
        GetMeetingForSelect ()
        
      },[])



    useEffect(() => {
        async function GetBorrowThree() {
            setLoading(true)
            try {
                let res = await fetch(`api/ProposalBorrow/GetProposalBorrow4ViewDataedit/${meetingNo}/${meetingYear}/${meetingDate}`);
                let resJson = await res.json();
                console.log(resJson.dataenum)
                setData(resJson.dataenum);
                // console.log("borrowInfo", resJson.dataenum);
            } catch (e) {
                console.log("err =>", e)

            } finally {
                setLoading(false)
            }
        }
        GetBorrowThree()
    }, [meetingNo, meetingYear, meetingDate])

    const fromInitialValues = {
        meetingNo: "",
        meetingYear: "",
        meetingDate: ""
    }
   
    return(
        <Formik
        initialValues={fromInitialValues}
        enableReinitialize
            >
                {({values,errors,touched,setFieldValue,handleBlur,handleChange}) => {

                    async function getYearForSelect (e) {
                        let postData = new FormData()
                        postData.append("meetingNo",e.target.value)
                        console.log("meetingNo",e.target.value)
                        try{
                            let res = await fetch("api/ProposalBorrow/getMeetingYearSelectTest",{
                            method:"POST",
                            body:postData
                        })
                        let resJson = await res.json()
                        // console.log("resjson",resJson.dataenum)
                        setMeetingYearSelect(resJson.dataenum)
                        }catch(e) {
                        console.log("err",e)
                        }
                    }
                    return(
                        <Container>
                            {!loading ? (
                            <>
                                <div className="d-flex justify-content-center align-items-center mb-2">
                                    <Form
                                        className="d-flex align-items-center justify-content-end w-75"
                                        // onSubmit={formik.handleSubmit}
                                        autoComplete="off"
                                    >
                                        <div className="d-flex align-items-center justify-content-start w-50 mx-1">
                                            <span className="w-75 text-center">ครั้งที่</span>
                                            <Input
                                                name="meetingNo"
                                                type="select"
                                                className="text-center w-100 rounded-pill input-color"
                                                onChange={(e)=> {
                                                    handleChange(e)
                                                    getYearForSelect(e)
                                                    setMeetingNo(e.target.value)
                                                    }}
                                                onBlur={handleBlur}
                                                value={values.meetingNo}
                                                >
                                                    <option defaultValue={"กรุณาเลือก"}>
                                                    กรุณาเลือก
                                                    </option>
                                                    {meetingNoSelect.map((item,k) => (
                                                    <option key={k} value = {item.meetingNo}>
                                                        {item.meetingNo}
                                                    </option>
                                                    ))}
                                                </Input>

                                        </div>
                                        <div className="d-flex align-items-center justify-content-start w-50 mx-1">
                                            <span className="w-75 text-center">ปี</span>
                                            <Input
                                                name="meetingYear"
                                                type="select"
                                                className="text-center w-100 rounded-pill input-color"
                                                onChange={(e)=> {
                                                    handleChange(e)
                                                    setMeetingYear(e.target.value)
                                                    }}
                                                onBlur={handleBlur}
                                                value={values.meetingYear}
                                                >
                                                    
                                                    <option defaultValue={"กรุณาเลือก"}>
                                                    กรุณาเลือก
                                                    </option>
                                                    {meetingYearSelect.map((year,i) => (
                                                    <option key={i} value ={year.meetingYear}>
                                                        {year.meetingYear}
                                                    </option>
                                                    ))}
                                                </Input>

                                        </div>
                                        <div className="d-flex align-items-center justify-content-start w-50 mx-1">
                                            <span className="w-50 text-center">วันที่</span>
                                            <Field name="meetingDate">
                                                {({field, meta, form}) => {
                                                
                                                    return(
                                                    <DatePicker
                                                        selected={field.value ? new Date(field.value) : null}
                                                        locale="th-buddhist"
                                                        showIcon
                                                        calendarClassName="thai-buddhist"
                                                        dateFormat="dd MMMM yyyy"
                                                        value={ConvertDateToThaiBuddhist(field.value)}
                                                        isClearable={true}
                                                        placeholderText="กรุณาเลือก"
                                                        renderCustomHeader={RenderCustomHeader}
                                                        onChange={(date) => {
                                                            form.setFieldValue(field.name,ConvertDateFormat(date))
                                                            setMeetingDate(ConvertDateFormat(date))
                                                        }}
                                                        customInput={
                                                        <Input
                                                            type="text"
                                                            className={
                                                            touched.meetingDate && errors.meetingDate
                                                                ? "input-error rounded-pill text-center input-color custom-placeholder"
                                                                : "rounded-pill text-center input-color custom-placeholder"
                                                            }
                                                            value={ConvertDateToThaiBuddhist(field.value)}
                                                            onChange={() => {}}
                                                            onBlur={field.onBlur}
                                                        />
                                                        }
                                                    />
                                                    )                                
                                                }}
                                            </Field>

                                        </div>
                                        <Button className="btn border border-1 mx-5 w-25 btn-green" href={`api/ProposalBorrow/getExeclFourth/${meetingNo}/${meetingYear}/${meetingDate}`} download>Export Excel</Button>
                                    </Form>
                                </div>
                                <div className="outer-wrapper">
                                <div className="table-wrapper">
                                    <table>
                                        <thead>
                                            <tr>
                                            <th rowSpan="3">ลำดับ</th>
                                            <th rowSpan="3">เลขที่คำขอ</th>
                                            <th rowSpan="3">ผู้ขอกู้</th>
                                                            <th colSpan="2">ประเภทกู้ยืม</th>
                                            <th rowSpan="3">ประเภทกิจการ</th>
                                                            <th rowSpan="3">จำนวนลูกจ้างทั้งสิ้น(คน)</th>
                                                            <th colSpan="10">รายละเอียดกู้ยืม</th>
                                            <th colSpan="2">หลักประกัน(บุคคลค้ำประกัน)</th>
                                            <th rowSpan="3">หน่วยงานที่รับคำขอกู้ยืมเงิน</th>
                                            </tr>
                                            <tr>
                                                    <th rowSpan="2">ผู้ดำเนินการทดสอบ</th>
                                                    <th rowSpan="2">ผู้ประกอบกิจการ</th>
                                                    <th colSpan="2">การดำเนินการทดสอบ</th>


                                                    <th rowSpan="2">สาขาอาชีพ</th>
                                                    <th rowSpan="2">สาขา</th>
                                                    <th rowSpan="2">ระดับ</th>
                                                    <th rowSpan="2">ระยะเวลาฝึกอบรม (ชั่วโมง)</th>
                                                    <th rowSpan="2">วันที่เริ่มฝึก</th>
                                                    <th rowSpan="2">วันที่จบการฝึก</th>
                                                    <th rowSpan="2">จำนวน (คน)</th>
                                                    <th rowSpan="2">รวมวงเงินที่ขอกู้ (บาท)</th>
                                                    <th rowSpan="2">ชื่อ-สกุล</th>
                                                    <th rowSpan="2">ตำแหน่ง</th>
                                                </tr>
                                                <tr>
                                                    <th >ทดสอบเอง</th>
                                                    <th >ส่งไปฝึก</th>
                                                    
                                                </tr>
                                        </thead>
                                        <tbody>
                                        {!data.length ? (
                                            <tr>
                                            <td className="text-center border-none" colSpan={9}>ไม่พบข้อมูล</td>
                                            </tr>
                                        ):(
                                        <>
                                            {data.map((item,i) => (
                                            <tr key={i}>
                                                <td>{i+1}</td>
                                                {/* เลขที่คำขอกู้ยืมเงิน */}
                                                <td>{item.borrowNumber}</td>
                                                {/* ชื่อผู้ขอกู้ยืม */}
                                                <td>{item.employee}</td>
                                                {/* ประเภทการสมัคร */}
                                                <td>{item.typeTrain ? <TiTick/> : "-"}</td>
                                            {/* ประเภทกิจการ */}
                                                <td>{item.typeComp ? <TiTick/> : "-"}</td>
                                                {/*ทุนจดทะเบียน  */}
                                                    <td>{item.businessType}</td>
                                                    <td className="text-center">{item.employeeAmount}</td>
                                                    {/*<td>{item.employeeAmount}</td>*/}
                                                    <td className="text-center">{item.lift ? <TiTick/> : "-"}</td>
                                                    <td className="text-center">{item.change ? <TiTick/> : "-"}</td>
                                                    <td>{item.lawOccupationName}</td>
                                                    <td>{item.testOccupationName}</td>
                                                    <td className="text-center">{item.stdLevelTname}</td>
                                                    <td>-</td>
                                                    <td>{item.startDate}</td>
                                                    <td>{item.endDate}</td>
                                                    <td className="text-center">{item.personTotal}</td>
                                                    <td className="text-center">{NumberWithCommas(item.amountLimit)}</td>
                                                    <td>{item.name}</td>
                                                    <td>{item.position}</td>
                                                    <td>{item.site}</td>
                                            </tr>

                                            ))} 
                                        </>
                                        )}
                                        </tbody>
                                    </table>
                                </div>
                                </div>
                            </>
                            ):(<Loading/>)}
                            
                        </Container>





                    )
                }}


        </Formik>

      
      

    )

}